import { useEffect } from 'react';
import { type Control, useWatch } from 'react-hook-form';

import { type ProductData, productStore } from '@/stores/productStore';

export const useZustandSync = <T>(
  control: Control<any>,
  mapper: (formData: T, product: ProductData) => Partial<ProductData>
) => {
  const values = useWatch({ control });

  useEffect(() => {
    const mappedValues = mapper(values, productStore.getState());
    productStore.getState().setFields(mappedValues);
  }, [values, mapper]);
};
